import React from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { Sandbox } from '../../types/sandbox';

interface SandboxTimelineChartProps {
  sandboxes: Sandbox[];
  days?: number;
}

export const SandboxTimelineChart: React.FC<SandboxTimelineChartProps> = ({
  sandboxes,
  days = 7,
}) => {
  // Generate data for the last N days
  const generateTimelineData = () => {
    const now = new Date();
    const data: Array<{ date: string; count: number }> = [];

    for (let i = days - 1; i >= 0; i--) {
      const date = new Date(now);
      date.setDate(date.getDate() - i);
      date.setHours(0, 0, 0, 0);

      const nextDate = new Date(date);
      nextDate.setDate(nextDate.getDate() + 1);

      // Count sandboxes created on this day
      const count = sandboxes.filter((sandbox) => {
        const createdAt = new Date(sandbox.created_at);
        return createdAt >= date && createdAt < nextDate;
      }).length;

      data.push({
        date: date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }),
        count,
      });
    }

    return data;
  };

  const data = generateTimelineData();

  if (sandboxes.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: '40px 0', color: '#8c8c8c' }}>
        No sandbox data available
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="date" />
        <YAxis allowDecimals={false} />
        <Tooltip />
        <Legend />
        <Line
          type="monotone"
          dataKey="count"
          stroke="#1677ff"
          activeDot={{ r: 8 }}
          name="Sandboxes Created"
        />
      </LineChart>
    </ResponsiveContainer>
  );
};
